import { blender } from '@/utils/blender';
import { createSelector } from '@reduxjs/toolkit';
import { getPromotedSearchResults } from '@/redux/modules/searchPromoted.selectors';
import { getSearchedItemIds } from '@/redux/modules/search/search.selectors';
import { GlobalState } from '@/redux/store';

// Search selectors can get very, very complex.
// Because of that, circular dependencies are going to be common.
// To avoid that, this file should contain selectors that pull from multiple slices.
// When it's all minified it would run fine, since everything's in one file,
// but test runs exploderate. 💥

const idSelector = (_: GlobalState, id: number | boolean | string) => id;

export const getSearchedAndPromotedItems = createSelector(
    [idSelector, getSearchedItemIds, getPromotedSearchResults],
    (columns: number, itemIds, promotedItemIds) => blender(itemIds, promotedItemIds, columns)
);
